import Header from "../../Components/Header/Header";
import FilterSearchForm from "../../Components/FilterSearchForm/FilterSearchForm";
import DropDownSearch from "../../Components/DropDownSearch/DropDownSearch";

function FilterSearchPage() {
    return (
        <>
            <Header />
            <FilterSearchForm />
        </>
    )
}
export default FilterSearchPage;